import { useSlate } from '@tribeplatform/react-slate-kit/hooks'
import {
  type SectionProps,
  type CompiledBlock,
} from '@tribeplatform/react-slate-kit/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { SlateTreeItemInfo } from './types.js'
import { getColumnIconNames } from './utils/utils.js'

interface Props {
  item: SlateTreeItemInfo
}

export const ColumnBlockIcon = ({ item }: Props) => {
  const {
    compiledSlate: { blocks },
  } = useSlate()
  const sectionBlock = blocks[item.data.parentId] as CompiledBlock<SectionProps>

  if (!sectionBlock) {
    return <SvgIcon size="md" name="block" />
  }

  const { layout } = sectionBlock.props
  const columnIndexInSection = sectionBlock.children.findIndex(
    id => id === item.data.id,
  )

  const iconNames = getColumnIconNames(layout)
  // The order and number of children (columns) in a section block is guaranteed to
  // match the layout, so we can safely use the column index to determine the icon name.
  const iconName = iconNames[columnIndexInSection]

  return (
    <span className="text-interactive">
      <SvgIcon size="md" name={iconName} />
    </span>
  )
}
